export default __webpack_public_path__ + "static/media/venus-de-milo.de943186.svg";